import { useEffect, useState } from 'react';
import Grid from '@material-ui/core/Grid';

import Site from '../Components/Site';
import SiteDetails from '../Components/SiteDetails';
import { siteInfo } from '../utils/siteInfo';
import * as constants from '../utils/constants';

function SiteContainer() {
  const [selectedSite, setSelectedSite] = useState('00');
  const [siteData, setSiteData] = useState({});

  const options = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'Access-Control-Allow-Credentials': true,
      'Access-Control-Allow-Origin': '*'
    }
  };

  const getData = (url, cb) => {
    fetch(url, options)
      .then((response) => {
        if (response.status === 200) {
          return response.json();
        } else {
          throw new Error(`Response status ${response.status}`);
        }
      }).then((responseJson) => {
        cb(responseJson)
      })
      .catch((error) => {
        console.log(error)
      });
  }

  const onSiteClick = (siteKey) => {
    setSelectedSite(siteKey)
  }

  useEffect(() => {
    //getData(constants.API_BASEURL + 'atlas.json', setSiteData);
    getData(constants.LOCAL_DATA_PATH + 'atlas.json', setSiteData);
    const dataInterval = setInterval(() => {
      //getData(constants.API_BASEURL + 'atlas.json', setSiteData);
      getData(constants.LOCAL_DATA_PATH + 'atlas.json', setSiteData);
    }, constants.POLL_INTERVAL);

    return () => clearInterval(dataInterval);
  }, []);

  if (selectedSite === '00') {
    return (
      <Grid container spacing={2}>
        {Object.keys(siteInfo).map((siteKey) => {
          return (
            <Grid item xs={12} sm={3}>
              <Site
                siteData={siteData[siteKey]}
                siteName={siteInfo[siteKey].name}
		siteCode={siteInfo[siteKey].ATLAScode}
                siteMPCcode={siteInfo[siteKey].MPCcode}
		timezone={siteInfo[siteKey].timezone}
                siteKey={siteKey}
                onClickCallback={onSiteClick}
              />
            </Grid>
          )
        })}
      </Grid>
    );
  } else {
    return (
      <SiteDetails
        siteData={siteData[selectedSite]}
        siteName={siteInfo[selectedSite].name}
        siteCode={siteInfo[selectedSite].ATLAScode}
        siteMPCcode={siteInfo[selectedSite].MPCcode}
	timezone={siteInfo[selectedSite].timezone}
        siteKey={selectedSite}
        onClickCallback={onSiteClick}
        closePopup={() => setSelectedSite('00')}
      />
    );
  }

}

export default SiteContainer;
